import { Alert, Link, Typography, useResolution, useTheme } from '@lingoda/ui';
import { CalendarDotIcon } from '@lingoda/ui/icons/lingodaIcons';
import { Translate, trans } from '@lingoda/i18n';
import { cancellationPolicyPath } from '@lingoda/router';

export const ClassesInPauseAlert = () => {
    const lessThanSmall = useResolution('phone');
    const theme = useTheme();

    return (
        <Alert
            variant="outlined"
            severity="info"
            icon={
                !lessThanSmall && <CalendarDotIcon size={24} color={theme.palette.text.secondary} />
            }
            title={trans('rollover-pause-you-have-bookings', {}, 'student-common')}
            sx={{ p: 2, mt: 3 }}
        >
            <Typography variant="body2" htmlColor="text.secondary">
                <Translate
                    id="rollover-pause-we-detected"
                    params={{
                        policyLink: (
                            <Link
                                key="policy-link"
                                color="inherit"
                                to={cancellationPolicyPath()}
                                target="_blank"
                            >
                                {trans(
                                    'rollover-pause-according-to-cancellation-policy',
                                    {},
                                    'student-common',
                                )}
                            </Link>
                        ),
                    }}
                    domain="student-common"
                />
            </Typography>
        </Alert>
    );
};
